import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { checkValue, formatDate } from 'utils';

export const columns = [
  {
    title: 'Номер счета в БЦК',
    dataIndex: 'bcc_account',
    key: 'bcc_account',
    filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
      return (
        <TableSearchPanel>
          <Input
            autoFocus
            placeholder="Поиск по номеру счета"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
          />
        </TableSearchPanel>
      );
    },
    filterIcon: () => <SearchOutlined />,
    onFilter: (value, record) => {
      return record.bcc_account.toLowerCase().includes(value.toLowerCase());
    },
  },
  {
    title: 'Партнер',
    dataIndex: 'admin_company',
    key: 'admin_company',
    render: checkValue,
  },
  {
    title: 'ФИО Партнера',
    dataIndex: 'admin_fio',
    key: 'admin_fio',
    render: checkValue,
    filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
      return (
        <TableSearchPanel>
          <Input
            autoFocus
            placeholder="Поиск по ФИО партнера"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
          />
        </TableSearchPanel>
      );
    },
    filterIcon: () => <SearchOutlined />,
    onFilter: (value, record) => {
      if (record.admin_fio) {
        return record.admin_fio.toLowerCase().includes(value.toLowerCase());
      }

      return null;
    },
  },
  {
    title: 'Активный',
    dataIndex: 'is_active',
    key: 'is_active',
    render: (value) => (value ? 'Да' : 'Нет'),
  },
  {
    title: 'Дата создание',
    dataIndex: 'create_date',
    key: 'create_date',
    render: (date) => {
      if (date === checkValue(date)) return formatDate(date);
      return checkValue(date);
    },
  },
  {
    title: 'Дата обновление',
    dataIndex: 'update_date',
    key: 'update_date',
    render: (date) => {
      if (date === checkValue(date)) return formatDate(date);
      return checkValue(date);
    },
  },
];
